import {
  SortableHeader,
  SortIndicator,
} from './BackofficeLayout.styled';
import type { ThSortableProps } from './types';

const ThSortable: React.FC<ThSortableProps> = ({
  label,
  sortKey,
  activeKey,
  direction,
  onToggle,
}) => {
  const active = sortKey === activeKey;
  return (
    <SortableHeader $active={active} onClick={() => onToggle(sortKey)}>
      {label}
      {active && <SortIndicator $direction={direction} />}
    </SortableHeader>
  );
};

export default ThSortable;
